import request from "@/utils/request";
import { ENABLE_API_DBG } from "@/appConfig.js";

function list(params) {
  const newParams = { ...params };
  if (newParams.max) {
    newParams.take = newParams.max;
    delete newParams.max;
  }
  if (newParams.offset) {
    newParams.skip = newParams.offset;
    delete newParams.offset;
  }

  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(newParams)) {
    qsParams.append(key, value);
  }

  const url = `/channel-dept-whitelist?${qsParams.toString()}`;
  ENABLE_API_DBG && console.log(`api.chnlWhitelist.list: url = ${url}`);

  return request({
    url,
    method: "get",
    data: newParams,
  });
}
function get(itemId) {
  return request({
    url: `/channel-dept-whitelist/${itemId}`,
    method: "get",
  });
}
function search(params) {
  return request({
    url: `/channel-dept-whitelist/search`,
    method: "post",
    data: params,
  });
}
function addWhiteDept(params) {
  return request({
    url: `/channel-dept-whitelist`,
    method: "post",
    data: params,
  });
}
function update(params) {
  return request({
    url: `/channel-dept-whitelist/${params.id}`,
    method: "patch",
    data: params,
  });
}
function removeWhiteDept(itemId) {
  const url = `/channel-dept-whitelist/${itemId}`;
  ENABLE_API_DBG &&
    console.log(`api.chnlWhitelist.removeWhiteDept: url = ${url}`);
  return request({
    url,
    method: "delete",
  });
}
export default {
  list,
  search,
  addWhiteDept,
  update,
  removeWhiteDept,
  get,
};
